import { useParams, useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import NotFound from "../../../components/not-found";
import ShoppingCompanyService from "../../../services/ShoppingCompanyService";
import ShoppingCompany from "../../../models/ShoppingCompany";
import ShoppingCompanyEditForm from "./ui/shopping-company-edit-form";
import ShoppingCompanySkeleton from "./skeleton/shopping-company-skeleton";

export default function ShoppingCompanyEditPage() {
  const [searchParams] = useSearchParams();
  const reload = searchParams.get("reload");
  const { id } = useParams();
  const [item, setItem] = useState<ShoppingCompany>();
  const [loading, setLoading] = useState(true);

  const fetchItem = useCallback(async () => {
    if (!id) {
      setLoading(false);
      return;
    }

    const api = new ShoppingCompanyService();
    try {
      const data = await api.getShoppingCompanyById(id);
      setItem(data);
    } catch (error) {
      console.error("Error fetching shopping company:", error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    void fetchItem();
  }, [fetchItem, reload]);

  if (!item && !loading) {
    return <NotFound message="Shopping company not found." />;
  }

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Shopping Companies", href: "/admin/shopping-companies" },
          {
            label: "Edit",
            href: `/admin/shopping-companies/edit/${id}`,
            active: true,
          },
        ]}
      />
      {!loading && item ? (
        <ShoppingCompanyEditForm item={item} />
      ) : (
        <ShoppingCompanySkeleton />
      )}
    </main>
  );
}
